module.exports = __webpack_public_path__ + "img/hexagon-border.788b8db.svg";